import { AnyAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../';
import { ValidationStateType } from '../../layouts/devops-screen/types';

type N2NDeferredPasswordFieldValidationType = {
  readonly email?: ValidationStateType;
  readonly fullName?: ValidationStateType;
};

type N2NDeferredPasswordFieldValidationActionType = {
  readonly type: string;
  readonly payload?: {
    readonly fieldName: 'email' | 'fullName';
    readonly validationState?: ValidationStateType;
  };
};

// Actions
const INPUT_VALIDATION_EMAIL = 'n2n-field-validation/INPUT_VALIDATION_EMAIL';
const INPUT_VALIDATION_FULL_NAME =
  'n2n-field-validation/INPUT_VALIDATION_FULL_NAME';

// Initial State
const initialState: N2NDeferredPasswordFieldValidationType = {
  email: undefined,
  fullName: undefined
};

// Reducer
export const n2nDeferredPasswordFieldValidationReducer = (
  state = initialState,
  action: N2NDeferredPasswordFieldValidationActionType
): N2NDeferredPasswordFieldValidationType => {
  switch (action.type) {
    case INPUT_VALIDATION_EMAIL:
    case INPUT_VALIDATION_FULL_NAME:
      return Object.assign({}, state, {
        [action?.payload?.fieldName as string]: action?.payload?.validationState
      });
    default:
      return state;
  }
};

// Thunks
export function updateN2NDeferredPasswordFieldValidationEmail(
  payload: ValidationStateType
) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldValidation: { email }
    } = getState();
    if (email !== payload) {
      dispatch({
        type: INPUT_VALIDATION_EMAIL,
        payload: {
          fieldName: 'email',
          validationState: payload
        }
      });
    }
  }) as unknown as AnyAction;
}

export function updateN2NDeferredPasswordFieldValidationFullName(
  payload: ValidationStateType
) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldValidation: { fullName }
    } = getState();
    if (fullName !== payload) {
      dispatch({
        type: INPUT_VALIDATION_FULL_NAME,
        payload: {
          fieldName: 'fullName',
          validationState: payload
        }
      });
    }
  }) as unknown as AnyAction;
}
